import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";
import ReactGA from "react-ga4";
import siteConfig from "./siteConfig";

if (siteConfig.gaId) {
  ReactGA.initialize(siteConfig.gaId);
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
